import React from "react";
import "./AdminActs.css";
import bfLogo from "../assets/bf_logo.png";
import { useNavigate } from "react-router-dom";

function AdminActs() {
  const navigate = useNavigate();

  return (
    <div className="coming-container">
      <button className="back-btn" onClick={() => navigate("/admin")}>
        ← Back
      </button>

      <img src={bfLogo} alt="BF" className="coming-logo" />
      <h1 className="coming-title">Acts</h1>

      <div className="coming-card">
        <p className="coming-text">
          This module will be available in <strong>version 1.1</strong>.
        </p>
        <p className="coming-sub">
          Digital acts, signatures and legal documents.
        </p>
      </div>
    </div>
  );
}

export default AdminActs;
